import React from 'react';
import TextField from '../../../components/common/TextField';
import { formatNumber } from '../../../common/Util';
import Typography from '../../../components/common/Typography';
import { useTranslation } from 'react-i18next';

//배열아니고 object 일 때
const InputItemSection = ({
  title,
  dataList,
  inputList = [],
  onChange = () => {},
  disabled = false,
  htmFlag = '',
}) => {
  const { t } = useTranslation('deductions/other');
  const getValue = input => {
    if (input.isNumber) {
      return formatNumber(dataList[input.key] || '0');
    }

    if (htmFlag == '5') {
      return dataList[input.key] == '1'
        ? t('detail.type5.inputLabel9')
        : t('detail.type5.inputLabel10');
    }
    return dataList[input.key];
  };

  return (
    <div className="housingItemSection">
      <Typography variant="body2Bold">{title}</Typography>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {inputList.map((input, index) => (
          <TextField
            key={index}
            {...input}
            size="small"
            name={input.key}
            onChange={onChange}
            value={getValue(input) || ''}
            disabled={input.disabled || disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default InputItemSection;
